import type { CategoryMenu } from '../../types';
import { MenuItem } from './menu-item';
import styles from './styles.module.scss';

interface MenuCategoryProps {
  category: CategoryMenu;
}

function MenuCategory({ category }: MenuCategoryProps) {
  return (
    <div className={styles.menuCategoryContainer}>
      {category.title && (
        <p className={styles.menuCategory} data-testid="category-title">
          {category.title}
        </p>
      )}
      {category.menus.map(menu => {
        return <MenuItem key={menu.key} menu={menu} />;
      })}
    </div>
  );
}

export { MenuCategory };
